import React from 'react';
import { getTags } from './ListingTags.helpers';
import { ListingTagsContainer, ListingTag } from './ListingTags.styles';
import { ListingTagsProps } from './ListingTags.types';

const ListingTags = ({
    data: { tags, statusSummary }
}: {
    data: ListingTagsProps;
}) => {
    const tagList = getTags({ tags, statusSummary });

    if (!tagList.length) {
        return <></>;
    }

    return (
        <ListingTagsContainer data-testid="tags-wrapper">
            {tagList.map((tag, key) => (
                <ListingTag bgColor={tag.color} key={`${tag.value}-${key}`}>
                    {tag.value}
                </ListingTag>
            ))}
        </ListingTagsContainer>
    );
};

export default ListingTags;
